<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter">
            <el-form-item label="处理状态：">
                <el-select v-model="searchForm.disposeState" clearable>
                    <el-option label="待审核" value="1"></el-option>
                    <el-option label="通过" value="2"></el-option>
                    <el-option label="拒绝" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="问题类型：">
                <el-select v-model="searchForm.complainatType" clearable>
                    <el-option label="投诉上级" value="1"></el-option>
                    <el-option label="公司意见" value="2"></el-option>
                    <el-option label="其他投诉" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getListPageHandle" icon="el-icon-search">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  > 
            <el-table-column type="index" label="序号"  width="60"></el-table-column>
            <el-table-column prop="complainatName" label="用户" ></el-table-column>
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column prop="disPoseStateName" label="处理状态" ></el-table-column>
            <el-table-column prop="complainatTypeName" label="问题类型" ></el-table-column>
            <el-table-column prop="disposeRemark" label="备注" ></el-table-column>
            <el-table-column prop="disposeName" label="处理人"></el-table-column>
            <el-table-column label="操作" width="230" fixed="right">
                <template slot-scope="scope" >
                    <el-button type="text" size="small" v-if="scope.row.disposeState != 1" @click="showOrderDetail(scope.row)">投诉详情</el-button>
                    <el-button type="text" size="small" v-if="scope.row.disposeState == 1" @click="showDisposeDetailVisible(scope.row)">
                    处理</el-button>
                </template>                
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmDialogVisible"
            width="30%">
            <span v-show='disposeDate.disposeState == 2'>确定要同意投诉吗</span>
            <span v-show='disposeDate.disposeState == 3'>确定要拒绝投诉吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleDispose">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="投诉详情"
            :visible.sync="orderDetailVisible"
            width="30%">
            <label>投诉详情</label>
            <el-input  type="textarea" placeholder="请输入详细内容并在下方上传证据截图" :rows="5" v-model.trim="echoComplainatRemark" clearable :disabled="true"></el-input>
            <div style="margin-top:10px;">证据截图：</div>
            <el-image v-for="url in complainatPhotos" 
            class="complainatPhotos"
            :key="url" :src="url" 
            :preview-src-list="complainatPhotos" lazy></el-image>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :append-to-body="true" 
            title="投诉审核"
            :visible.sync="disposeDetailVisible"
            width="30%">
            <label>投诉详情</label>
            <el-input  type="textarea" placeholder="请输入详细内容并在下方上传证据截图" :rows="5" v-model.trim="echoComplainatRemark" clearable :disabled="true"></el-input>

            <div style="margin-top:10px;">证据截图：</div>
            <el-image v-for="url in complainatPhotos" 
            class="complainatPhotos"
            :key="url" :src="url" 
            :preview-src-list="complainatPhotos" lazy></el-image>

            <div style="margin-top:10px;">审核备注：</div>
            <el-input  type="textarea" placeholder="请输入审核备注" :rows="5" v-model.trim="disposeDate.disposeRemark" clearable ></el-input>

            <span slot="footer" class="dialog-footer">
                <el-button  @click="hideDisposeDetailVisible">取 消</el-button>
                <el-button  @click="disagreeComplainat">拒 绝</el-button>
                <el-button type="primary" @click="agreeComplainat">同 意</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getComplaintsList, doDisposeComplaint} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                disposeState: '',
                complainatType: ''
            },
            complainatType:'',
            complainatRemark:'',
            formDate:'',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //投诉审核
            disposeDate:{
                id:'',
                disposeRemark:'',
                disposeState:''
            },

            orderDetailVisible : false,//投诉内容显示框
            disposeDetailVisible:false,//投诉审核显示框
            disposeRemark:'',//回复内容
            echoComplainatRemark:'',//回显的投诉内容
            complainatPhotos:[],//回显截图路径
            confirmDialogVisible:false//确认对话框
        }
    },
    methods: {
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getComplaintsList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showOrderDetail(row){
            let photosArray = row.complainatPhotos.split("@@");
            for(let i=0; i<photosArray.length; i++){
                this.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
            }
            this.echoComplainatRemark = row.complainatRemark;
            this.orderDetailVisible = true;
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getListPageHandle();
        },

        //关闭 投诉审核显示框
        hideDisposeDetailVisible(){
            this.disposeDate.disposeRemark = '';
            this.disposeDate.disposeState = '';
            this.disposeDetailVisible = false;
        },

        //打开 投诉审核显示框
        showDisposeDetailVisible(row){
            let photosArray = row.complainatPhotos.split("@@");
            for(let i=0; i<photosArray.length; i++){
                this.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
            }
            this.echoComplainatRemark = row.complainatRemark;
            this.disposeDate.id = row.id;
            this.disposeDetailVisible = true;
        },
        //同意投诉
        agreeComplainat(){
            this.disposeDate.disposeState = 2;
            this.confirmDialogVisible = true;
        },

        //拒绝投诉
        disagreeComplainat(){
            this.disposeDate.disposeState = 3;
            this.confirmDialogVisible = true;
        },


        //投诉回复
        handleDispose(){
            doDisposeComplaint(this.disposeDate).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmDialogVisible = false;
                this.disposeDetailVisible = false;
                this.disposeDate.id = '';
                this.disposeDate.disposeRemark = '';
                this.disposeDate.disposeState = '';
                this.getListPageHandle();
            });
        }        
    },
    created(){
        this.getListPageHandle();
    }
}
</script>
<style lang="less" scoped>
    .toolsbar{
        margin-bottom:10px;
    }
    .complainatPhotos{
        max-width: 200px; 
        max-height: 200px; 
        border:1px solid #cccbcb; 
        margin:5px 10px;
    }
    .el-textarea.is-disabled .el-textarea__inner{
        color:#2f2f2f
    }
</style>
